import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-classes-ranking-classif',
  templateUrl: './classes-ranking-classif.component.html',
  styleUrls: ['./classes-ranking-classif.component.scss']
})
export class ClassesRankingClassifComponent implements OnInit {
    /**
     * Definição para receber o identificador do ranking
     */
    rankingId: string;

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.rankingId = this.route.snapshot.paramMap.get('rankingId');
    }
}
